<template>
  <div>
    <b-container>
      <div>
        <b-modal v-model="modalShow">{{ messagge }}</b-modal>
      </div>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                <h6 class="mb-0">Datos del Asegurado</h6>
                <b-button size="sm" variant="outline-secondary" type="button" @click="demoFillMax">
                  Rellenar datos de prueba (máx.)
                </b-button>
              </div>
            </template>
            <b-row>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="groupNumber" rules="required" disabled label="Póliza Nro." />
              </b-col>
              <b-col md="3" cols="12">
                <SelectComponent
                  :form="form"
                  name="procedimiento"
                  label="Procedimiento"
                  :options="control.TIPOS_PROCEDIMIENTO"
                  disabled
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" cols="12">
                <TextComponent
                  :form="form"
                  name="firstName"
                  label="Primer Nombre"
                  rules="required|alpha_spaces|max:20"
                />
              </b-col>
              <b-col md="4" cols="12">
                <TextComponent :form="form" name="secondFirstName" label="Segundo Nombre" rules="alpha_spaces|max:20" />
              </b-col>

              <b-col md="4" cols="12">
                <TextComponent :form="form" name="lastName" label="Apellidos" rules="required|alpha_spaces|max:20" />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4" cols="12">
                <TextComponent
                  :form="form"
                  name="email"
                  label="Correo Electrónico"
                  disabled
                  rules="required|email|max:150"
                />
              </b-col>
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  type="date"
                  name="birthDay"
                  label="Fecha de Nacimiento"
                  rules="required|date_min:01/01/1900,DD/MM/YYYY|date_max:today"
                />
              </b-col>

              <b-col md="2" cols="12">
                <RadioComponent :form="form" name="sex" label="Género" rules="required" :options="control.TIPOS_SEXO" />
              </b-col>

              <b-col md="2" cols="12">
                <SelectComponent
                  :form="form"
                  name="identificationType"
                  label="Tipo Documento"
                  rules="required"
                  :options="control.IdentificationsType"
                />
              </b-col>

              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="identification"
                  label="Número de Identificación"
                  rules="required"
                  disabled
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="ocupacity" label="Actividad" rules="max:50" />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="adress" label="Dirección Residencia" rules="required|max:60" />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="city" label="Ciudad" rules="required|max:30" />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="apart" label="Departamento" rules="alpha_spaces|max:30" />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4" cols="12">
                <TextComponent :form="form" name="phone" label="Teléfono Residencia" type="number" rules="max:10" />
              </b-col>
              <b-col md="4" cols="12">
                <TextComponent :form="form" name="phoneOffice" label="Tel. Oficina" rules="max:20" />
              </b-col>
              <b-col md="4" cols="12">
                <TextComponent
                  :form="form"
                  name="phoneMobile"
                  label="Celular"
                  type="number"
                  rules="required|min:10|max:10"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="currentInsuredValue"
                  type="number"
                  label="Valor Asegurado Actual"
                  disabled
                />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent
                  :form="form"
                  name="requestedInsuredValue"
                  type="number"
                  label="Valor Asegurado Solicitado"
                  disabled
                />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="salary" type="number" label="Salario Mensuales" disabled />
              </b-col>

              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="stature"
                  type="number"
                  label="Estatura (m)"
                  step="0.01"
                  :min="1"
                  :max="2.5"
                  :disabled="!form.fisicEdit"
                  :rules="form.fisicEdit ? 'required' : ''"
                />
              </b-col>
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="weight"
                  type="number"
                  label="Peso (kg)"
                  step="0.1"
                  :min="35"
                  :max="300"
                  :disabled="!form.fisicEdit"
                  :rules="form.fisicEdit ? 'required' : ''"
                />
              </b-col>
            </b-row>

            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <!--SIGUIENTE-->
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import RadioComponent from "@/components/controls/RadioComponent.vue";
import SelectComponent from "@/components/controls/SelectComponent.vue";
import TextComponent from "@/components/controls/TextComponent.vue";

import { fillColombiaSaludDemoMax } from "@/helpers/colombiaSaludDemoFill";
import { isValidDateBeforeToday } from "@/helpers/dateHelper";
import {
  TIPOS_IDENTIFICACIONES,
  TIPOS_POLIZA,
  TIPOS_PROCEDIMIENTO,
  TIPOS_SEXO,
} from "../../../../data/colombia/salud/Selects";

export default {
  name: "FormColombia01",
  components: { TextComponent, RadioComponent, SelectComponent },
  data() {
    return {
      messagge: "",
      control: {
        IdentificationsType: TIPOS_IDENTIFICACIONES,
        TIPOS_POLIZA,
        TIPOS_PROCEDIMIENTO,
        TIPOS_SEXO,
      },
      form: {},
      modalShow: false,
    };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/salud/");
      return;
    }

    this.form = form;

    //this.form.observations = "CO102";

    this.form.fisicEdit =
      this.form.observations.includes("CO001") ||
      this.form.observations.includes("CO002") ||
      this.form.observations.includes("CO101") ||
      this.form.observations.includes("CO102");

    this.$store.dispatch("app/loading", false);
  },
  methods: {
    demoFillMax() {
      fillColombiaSaludDemoMax(this.form);
      this.$bvToast.toast(
        "Datos del asegurado, dos personas a asegurar y cuestionario (todo No) rellenados de prueba.",
        { title: "Datos de prueba", variant: "info", solid: true }
      );
    },

    next() {
      if (!isValidDateBeforeToday(this.form.birthDay)) {
        this.$bvToast.toast("La fecha de nacimiento no puede ser menor a 1900-01-01 o mayor a la fecha actual.", {
          title: "Problemas en validación",
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.$store.dispatch("wizard/save", { index: 1, form: this.form }).then(() => {
          this.$router.push("/form/colombia-salud-2.html");
      });
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1600px;
}
</style>
